import { useContext } from "react"
import { Offcanvas, Button, Dropdown, DropdownButton, Stack, ListGroup } from "react-bootstrap";
import { UserContext } from '../context/UserContext';
import { Link, useNavigate } from 'react-router-dom';
import { FiKey, FiLogOut, FiMap, FiCheckSquare } from 'react-icons/fi';


const MenuSideBar = (props) => {
    const { setToken, setRefreshToken, username, userenv } = useContext(UserContext)
    // `view` is the page the sidebar is rendered on: "blueprint" (default) or
    // "review". Switching deployment keeps the user on the same kind of page.
    const { isVisible, hideSideBar, selectedStoreName, selectedDeploymentId, deployments, view = "blueprint" } = props;
    const pathFor = (deploymentId) => view === "review" ? `/${deploymentId}/cameras-review` : `/${deploymentId}`;

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("sensei-user-token")
        localStorage.removeItem("sensei-refresh-token")
        localStorage.removeItem("sensei-user-name")
        localStorage.removeItem("sensei-user-id")
        localStorage.removeItem("sensei-user-env")

        setToken(null)
        setRefreshToken(null)
        navigate(`/`);
    }

    const handleSelect = (newDeploymentId) => {
        navigate(pathFor(newDeploymentId));
        hideSideBar();
    }

    return (
        <Offcanvas show={isVisible} onHide={() => { hideSideBar() }} placement="start">
            <Offcanvas.Header closeButton >
                <img src="/sensei-small-logo.jpg" alt="small sensei logo"/>
                <Offcanvas.Title className="text-secondary fs-4 fw-bold">Store Deployments</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="bg-red">
                <Stack gap={1}>

                    <ListGroup variant="flush">
                        <ListGroup.Item className="border-0 px-0">
                            <small className="text-muted">Store:</small>
                            <DropdownButton
                                id="dropdown-basic-button"
                                title={selectedStoreName}
                                onSelect={handleSelect}
                                variant="outline-primary"
                                className="w-100 dropdown-custom"
                            >
                                {deployments.map(d =>
                                    <Dropdown.Item eventKey={d.deployment_id} key={d.deployment_id}>{d.store_name}</Dropdown.Item>)
                                }
                            </DropdownButton>

                        </ListGroup.Item>

                        <ListGroup.Item className="border-0 px-0">
                            <small className="text-muted">User:</small>
                            <div className="fw-semibold">{username}</div>
                        </ListGroup.Item>

                        <ListGroup.Item className="border-0 px-0">
                            <small className="text-muted">Env:</small>
                            <div className="fw-semibold">{userenv}</div>
                        </ListGroup.Item>
                    </ListGroup>
                    {selectedDeploymentId !== undefined && (view === "review" ? (
                        <Link to={`/${selectedDeploymentId}`} className="change-password-btn mb-3" onClick={hideSideBar}>
                            <FiMap className="me-3" />
                            Store Blueprint
                        </Link>
                    ) : (
                        <Link to={`/${selectedDeploymentId}/cameras-review`} className="change-password-btn mb-3" onClick={hideSideBar}>
                            <FiCheckSquare className="me-3" />
                            Camera Review
                        </Link>
                    ))}
                    <Link to={"/change-password"} className="change-password-btn mb-3">
                        <FiKey className="me-3" />
                        Change Password
                    </Link>
                    <Button variant="dark" onClick={handleLogout}>
                        <FiLogOut className="me-3" />
                        Logout
                    </Button>
                </Stack>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default MenuSideBar;
